import { useSearchParams } from "react-router-dom";
import Products from "../../components/products/products";
import { Helmet } from "react-helmet";


export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query");

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Search Results - Find What You Need</title>
        <meta
          name="description"
          content="Browse search results on SHOP.CO. Discover products that match your search and filter by category, brand, or price."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/"
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Products searchQuery={query} />
    </>
  );
}

